<template>
  <div class="option-item">
    <span
      v-if="indexed"
      class="option-index"
    >
      {{ index }}
    </span>
    <div
      v-if="hasCheckbox"
      class="option-check"
    >
      <span class="checkmark" />
    </div>
    <div class="option-title">
      {{ option.title }}
    </div>
    <div class="option-status">
      <span class="checkmark" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    hasCheckbox: {
      type: Boolean,
      default: true,
    },
    indexed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.option-item {
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid var(--secondary-20, #D3D7E1);
  padding: 12px;
  display: flex;
  align-items: center;

  &.border-none {
    border-color: transparent !important;
  }

  &.border-secondary:not(.checked) {
    border-color: var(--secondary-15, #EFF1F7);
  }

  &.massive {
    .option-index {
      width: 28px;
    }
  }

  &.timeout {
    border-color: #AFAFAF;
    background-color: #F5F5F5;

    .option-status > .checkmark {
      visibility: visible;
      background-image: url('~@/assets/images/my-quiz-answer/wrong.svg');
    }
  }

  &.checked {
    border-color: #525F7F;
  }

  &:not(.multiple) {
    &:not(.checked) {
      .option-check > .checkmark {
        visibility: visible;
        background-image: url('~@/assets/images/my-quiz-answer/radio.svg');
      }
    }

    &.checked {
      .option-check > .checkmark {
        visibility: visible;
        background-image: url('~@/assets/images/my-quiz-answer/radio-checked.svg');
      }
    }
  }

  &.multiple {
    &:not(.checked) {
      .option-check > .checkmark {
        visibility: visible;
        background-image: url('~@/assets/images/my-quiz-answer/checkbox.svg');
      }
    }

    &.checked {
      .option-check > .checkmark {
        visibility: visible;
        background-image: url('~@/assets/images/my-quiz-answer/checkbox-checked.svg');
      }
    }
  }

  &.correct {
    .option-status > .checkmark {
      visibility: visible;
      background-image: url('~@/assets/images/my-quiz-answer/correct.svg');
    }
  }

  &.correct.alternative-correct-icon {
    .option-status > .checkmark {
      visibility: visible;
      background-image: url('~@/assets/images/check.svg');
    }
  }

  &.checked.incorrect {
    .option-status > .checkmark {
      visibility: visible;
      background-image: url('~@/assets/images/my-quiz-answer/incorrect.svg');
    }
  }
}

.option-index {
  width: 16px;
  color: var(--base-90, #313131);
  font-weight: 700;
}

.option-check {
  display: flex;
  align-items: center;
  width: 20px;
  flex-basis: 20px;
  flex-shrink: 0;
}

.checkmark {
  visibility: hidden;
  display: inline-block;
  width: 20px;
  height: 20px;
  flex-basis: 20px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.option-title {
  padding: 0 8px;
  flex-grow: 1;
  word-break: break-word;

  &:first-child {
    padding-left: 0;
  }
}

.option-status {
  width: 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
</style>
